import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Select,
  DatePicker,
  Alert,
  Typography,
  Spin,
  Flex,
  List,
  Table,
  Space,
  Popconfirm,
  Drawer,
  Input,
  message,
  Switch,
} from "antd";
import {
  CheckCircleOutlined,
  EditOutlined,
  SendOutlined,
  DeleteOutlined,
  DashOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import "./style.css";
import { useParams, useNavigate } from "react-router-dom";
import {
  useFetchTemperatureDataQuery,
  useAddTemperatureDataMutation,
  useFetchOneTemperatureDataQuery,
  useUpdateOneTemperatureDataMutation,
} from "./temperature.service";

import { setTemperatures } from "./temperature.slice";
import { useTranslation } from "react-i18next";
const { TextArea } = Input;
const { Option } = Select;

const Restaruant = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { id: uid } = useParams();
  const { data, isLoading, isSuccess } = useFetchOneTemperatureDataQuery(uid);
  const temperatures = useSelector((apps) => apps.temperature.temperatures);
  const [updateTemperatureData, { isSuccess: isUpdateSuccess }] =
    useUpdateOneTemperatureDataMutation();
  const dispatch = useDispatch();
  const restaruant = useSelector((apps) => apps.restaurant.res);
  const [form] = Form.useForm();

  useEffect(() => {
    if (isSuccess) {
      form.setFieldsValue({
        ...data.data,
        restaurant_id: data?.data?.restaurant_id?.name,
      });
    }
  }, [isSuccess, data]);

  useEffect(() => {
    if (isUpdateSuccess) navigate("/temperatures");
  }, [isUpdateSuccess]);

  const handleFormSubmit = async () => {
    const formData = form.getFieldsValue();

    try {
      const { data } = await updateTemperatureData({ ...formData, uid });
      dispatch(
        setTemperatures(
          temperatures.map((e) => (e._id != uid ? e : { ...e, ...data.data }))
        )
      );
    } catch (err) {
      console.log(err);
    }
  };

  if (isLoading)
    return (
      <Flex justify="center" align="center">
        <Spin />
      </Flex>
    );
  return (
    <Card
      title={t("Temperature Edit")}
      style={{ fontSize: "20px" }}
      bordered={false}
    >
      <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
        <Form.Item
          label={t("Sensor Name")}
          name="sensor_id"
          rules={[
            {
              required: true,
              message: "Please enter an sensor name",
            },
          ]}
        >
          <Input placeholder="Enter sensor name" />
        </Form.Item>

        <Form.Item
          label={t("Min Temperature")}
          name="min_temp"
          rules={[
            {
              required: true,
              message: "Please enter an min temp",
            },
          ]}
        >
          <Input placeholder="Enter temp" />
        </Form.Item>

        <Form.Item
          label={t("Max Temperature")}
          name="max_temp"
          rules={[
            {
              required: true,
              message: "Please enter an max temp",
            },
          ]}
        >
          <Input placeholder="Enter max temp" />
        </Form.Item>

        <Form.Item
          label={t("Temperature Unit")}
          name="temperature_unit"
          rules={[
            {
              required: true,
              message: "Please enter an temperature unit",
            },
          ]}
        >
          <Select
            placeholder="Enter temperature unit"
            options={[{ label: "C", value: "C" }]}
          />
        </Form.Item>

        <Form.Item label={t("Alert")} name="alert">
          <Switch />
        </Form.Item>

        <Form.Item
          label={t("Delay for alert")}
          name="delay_before_alert"
          rules={[
            {
              required: true,
              message: "Please enter an max temp",
            },
          ]}
        >
          <Input placeholder="Enter max temp" />
        </Form.Item>

        <Form.Item
          label={t("Alert Unit")}
          name="delay_unit"
          rules={[
            {
              required: true,
              message: "Please enter an alert unit",
            },
          ]}
        >
          <Select
            placeholder="Enter alert unit"
            options={[{ label: "minutes", value: "minutes" }]}
          />
        </Form.Item>

        <Flex justify="flex-end">
          <Button
            type="default"
            style={{ marginRight: 8 }}
            onClick={() => navigate("/temperatures")}
          >
            {t("Discard")}
          </Button>
          <Button type="primary" htmlType="submit">
            {t("Save")} {<SendOutlined />}
          </Button>
        </Flex>
      </Form>
    </Card>
  );
};

export default Restaruant;
